
import accountReport from '@/pages/report/accountReport'
import SummaryReport from '@/pages/report/SummaryReport'
import layout from '@/components/layout/layout'
const reportRouter =
{
  path: '/report',
  component: layout,
  meta: {roles: ['shop'], title: '管理报表', icon: 'icon-guanlibaobiaoon'},
  children: [
    {
      path: '/report/accountReport',
      component: accountReport,
      name: 'accountReport',
      meta: {roles: ['pingtai', 'zhifa','factory'], title: '对账报表'}
    },
    {
      path: '/report/summaryReport',
      component: SummaryReport,
      name: 'summaryReport',
      meta: {roles: ['shop'], title: '对账汇总'}
    }
  ]
}
export default reportRouter



// WEBPACK FOOTER //
// ./src/router/modules/reportRouter.js